import axios from 'axios';

export const API_URL = String(process.env.REACT_APP_API_URL ?? 'http://localhost:3001').replace(/\/+$/, '');

axios.interceptors.request.use(
    config => {
        config.headers.Authorization = localStorage.getItem('token');
        // Sempre adiciona o origin como header customizado
        if (typeof window !== 'undefined' && window.location) {
            config.headers['X-App-Origin'] = window.location.origin;
        }
        return config;
    },
    error => Promise.reject(error)
)

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // Token expirado ou inválido: limpa e redireciona para login
            try {
                localStorage.removeItem('token');
            } catch (e) {
                // Ignora falhas de storage
            }
            if (window.location.pathname !== '/') {
                window.location = '/';
            }
            return Promise.reject(error);
        }
        else
            return Promise.reject(error);
    });

export default axios;
